import React from "react";
import PropTypes from "prop-types";

import Scrubber from "./Scrubber";
import { defaultTrack } from "./DefaultTrack.module.scss";

const DefaultTrack = ({ progressPixel, position, onSeek }) => (
  <div className={defaultTrack}>
    <Scrubber left={progressPixel(position)} onMouseDown={onSeek}/>
  </div>
);

DefaultTrack.propTypes = {
  progressPixel: PropTypes.func.isRequired,
  position: PropTypes.number.isRequired,
  onSeek: PropTypes.func.isRequired
};

export default DefaultTrack;
